import {IMultiOccurrenceOptions} from '../../../../../core/services/multi-occurrence.service';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaireItemSautDeLigneClass } from '../../../../../core/services/formulaire/formulaire-item-saut-de-ligne.service';

interface IPageCP0056 {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
}

/* @ngInject */
export default function Cp0056Controller(Formulaire: IFormulaireClass,
                                         FormulaireItem: IFormulaireItemClass,
                                         FormulaireItemSautDeLigne: IFormulaireItemSautDeLigneClass) {
    const vm: IPageCP0056 = this;

    vm.multiOccurrenceOptions = {
        fonctions: {
            effaceCriteres: true,
            rechercheCollapsable: false,
            suiviModification: false
        },
        criteresSuggeres: new Formulaire([
            new FormulaireItem('datdebcri', { required: true }),
            new FormulaireItem('datfincri', { required: true }),
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('tydcleintcri', { lovSelectionMultiple: true, largeur: 30 }),
            new FormulaireItem('etdcleintinccri', { lovSelectionMultiple: true, largeur: 30 }),
            new FormulaireItem('etdcleintexccri', { lovSelectionMultiple: true, largeur: 30 })
        ]),
        colonnesVisibles: [
            {nom: 'tyddsc', largeur: 200},
            {nom: 'usrnom', largeur: 200},
            {nom: 'etddsc', largeur: 200},
            {nom: 'nbr'   , largeur: 120},
            {nom: 'datcre', largeur: 150}
        ]
    };
}
